/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../../../components/Modal';
import useForm from '../../../hooks/useForm';
import Form from '../../../components/Form';
import PartnerPreviewImage from "../../../assets/images/partners/partner-preview.png";
import { addressToCoord } from '../../../apis/maps';
import { toast } from '../../../utils/toast';
import { viewLoading } from '../../../utils/loading';
import { isEmpty } from '../../../utils/lodashExtend';
import systemAlert from '../../../utils/systemAlert';
import { addExternalProfiles, editExternalProfiles } from '../../../apis/externalProfile';
import TaxEmployeePreviewModal from '../../../components/TaxConsulting/TaxEmployeePreviewModal';
import Button from '../../../components/Button';
import { shallowEqual, useSelector } from 'react-redux';
import { getPartner } from '../../../apis/partner/partner';

const defaultForm = {
  isMain: "false",
  name: null,
  companyName: null,
  address: null,
  addressDetail: null,
  longitude: null,
  latitude: null,
  mobile: null,
  tel: null,
  area: null,
  imageFileIdx: null,
  mainTask: null,
};

const PartnerForm = ({ fields, fields2, buttons, ...props }) => {
  return (
    <>
      <div className="partner-form-wrap">
        <div className="partner-form" style={{ width: "49%" }}>
          <Form {...props} fields={fields} />
        </div>
        <div className="partner-form" style={{ width: "49%" }}>
          <div className="partner-preview-image-wrap">
            <h5 className="section-title">노출정보 미리보기</h5>
            <img
              className="partner-preview-image"
              src={PartnerPreviewImage}
              alt="노출정보 프리뷰"
            />
          </div>
          <Form {...props} fields={fields2} buttons={buttons} />
        </div>
      </div>
    </>
  );
};

const TaxConsultingCompanyModal = ({
  isOpen,
  setIsOpen,
  orgMode,
  submit,
  selectedItem,
  setSelectedItem
}) => {

  const { employee } = useSelector(
    (store) => ({
      employee: store.Profile.employee,
    }),
    shallowEqual
  );

  const close = () => {
    setIsOpen(false);
    setSelectedItem && setSelectedItem({});
    resetForm(defaultForm);
  };

  const [fields, setFields] = useState([]);
  const [fields2, setFields2] = useState([]);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [mode, setMode] = useState(orgMode);
  const [buttons, setButtons] = useState([]);

  const getCoord = async (form, setForm) => {
    if (form.address) {
      const address = form.address;
      const addresses = await addressToCoord({ address });
      if (addresses.length > 0) {
        form.latitude = addresses[0].y;
        form.longitude = addresses[0].x;
        setForm({ ...form });
      } else {
        toast.error("주소를 정확히 입력해주세요");
      }
    } else {
      toast.error("주소 입력 후 변환해 주세요.");
    }
  };

  const setExternal = async () => {
    viewLoading(true);
    const data = {
      ...selectedItem,
      logoFileIdx: selectedItem.logoFile ? [selectedItem.logoFile] : [],
      thumbnailFileIdx: selectedItem.thumbnailFile ? [selectedItem.thumbnailFile] : [],
      imageFileIdx: selectedItem.imageFile ? [selectedItem.imageFile] : [],
      employeeIdx: selectedItem.employeeIdx,
      isMain: selectedItem.isMain + ""
    };

    setOriginForm(data);
    setForm(data);
    viewLoading(false);

  };

  const _submit = (form) => {
    const params = {
      name: form.name,
      companyName: form.companyName,
      address: form.address,
      addressDetail: form.addressDetail,
      longitude: form.longitude,
      latitude: form.latitude,
      mobile: form.mobile,
      tel: form.tel,
      area: form.area,
      imageFileIdx: form.imageFileIdx[0],
      mainTask: form.mainTask,
      isMain: form.isMain === "true",
      description: form.description,
    };


    if (mode === "modify") {
      systemAlert("컨설팅 정보를 수정하시겠습니까?", {
        buttons: [{
          label: "취소",
          color: "line"
        }, {
          label: "수정",
          onClick: () => {
            editExternalProfiles(form.idx, params)
              .then(res => {
                toast.success("수정이 완료되었습니다.");
                submit && submit();
                close();
              });
          }
        }],
      });
    } else if (mode === "create") {
      systemAlert("컨설팅 정보를 등록하시겠습니까?", {
        buttons: [{
          label: "취소",
          color: "line"
        }, {
          label: "수정",
          onClick: () => {
            addExternalProfiles(params)
              .then(res => {
                toast.success("등록이 완료되었습니다.");
                submit && submit();
                close();
              });
          }
        }],
      });
    }
  };

  const getPartnerData = () => {
    viewLoading(true);
    getPartner(employee.companyIdx)
      .then(res => {
        const data = {
          companyName: res.name,
          address: res.address,
          addressDetail: res.addressDetail,
          longitude: res.longitude,
          latitude: res.latitude,
          area: res.area,
          imageFileIdx: !isEmpty(res.imageFile) ? [res.imageFile] : [],
          imageFile: res.imageFile,
          mainTask: res.mainTask,
          description: res.memo,
        };
        setFields([]);
        setForm(data);
      }).finally(() =>
        viewLoading(false)
      );
  };

  const {
    form,
    setForm,
    setOriginForm,
    errors,
    handleOnChange,
    handleSubmit,
    resetForm,
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    !isEmpty(selectedItem) && setExternal();
  }, [selectedItem]);

  useEffect(() => {
    setFields([
      [
        {
          title: "프로필 종류",
          key: "isMain",
          type: "radio",
          options: {
            list: [
              { label: "메인 프로필", value: "true" },
              { label: "서브 프로필", value: "false" },
            ],
          },
          required: true,
          tooltip: "메인프로필은 하나만 설정할 수 있습니다.\n메인 프로필이 하나도 없을 시 정확한 정보가 노출되지 않을 수 있습니다.",
          isHide: () => mode === "view"
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">1</span>
              </div>
              <div className="partner-form-title">
                프로필 사진
                {/* <span className="color-red-100">&nbsp;*</span> */}
                {mode !== "view" && <div className="partner-form-info">390x390 픽셀</div>}
              </div>
            </div>
          ),
          key: "imageFileIdx",
          type: "dropzone",
          isSingle: true,
          // after: `390x390 비율, ${whereToUse("자세히보기", false)}`,
          labelWidth: 120,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">2</span>
              </div>
              <div className="partner-form-title">
                세무사 명
                {mode !== "view" && (<span className="color-red-100">&nbsp;*</span>)}
              </div>
            </div>
          ),
          key: "name",
          placeholder: "세무사 입력",
          type: "input",
          required: true,
          isRequiredShow: false,
          labelWidth: 120,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">3</span>
              </div>
              <div className="partner-form-title">
                회사명
                {/* <span className="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "회사명 입력",
          key: "companyName",
          type: "input",
          // after: whereToUse(true, false),
          labelWidth: 120,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">4</span>
              </div>
              <div className="partner-form-title">
                주요업무
                {/* <span className="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "주요업무 입력",
          key: "mainTask",
          type: "textarea",
          // after: `엔터(줄바꿈)로 구분해주세요. ${whereToUse(
          //   "주요 업무",
          //   false
          // )}`,
          ...(mode !== "view" && { after: `엔터(줄바꿈)로 구분해주세요.` }),
          labelWidth: 120,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">5</span>
              </div>
              <div className="partner-form-title">
                주소
                {/* <span className="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "주소 입력",
          key: "address",
          type: "address",
          // after: whereToUse(true, true),
          labelWidth: 120,
          // isHide: () => mode === "view",
          disabled: mode === "view",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">8</span>
              </div>
              <div className="partner-form-title">
                소개글
              </div>
            </div>
          ),
          placeholder: "회사소개 입력",
          key: "description",
          type: "textarea",
          labelWidth: 120,
          after: `엔터(줄바꿈)로 구분해주세요.`,
          // after: `${whereToUse("자세히보기 제일 하단", false)}`,
        },
      ],
    ]);
    setFields2([
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">6</span>
              </div>
              <div className="partner-form-title">
                상담전화
                {/* <span className="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "상담전화 입력",
          key: "tel",
          type: "input",
          labelWidth: 120,
          // after: `${whereToUse(true, true)}, 텍스트 및 숫자 사용가능`,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">7</span>
              </div>
              <div className="partner-form-title">
                지역
                {/* <span className="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          key: "area",
          type: "select",
          options: {
            list: [
              { label: "없음", value: undefined },
              { label: "서울", value: "서울" },
              { label: "인천", value: "인천" },
              { label: "경기", value: "경기" },
              { label: "강원", value: "강원" },
              { label: "대전·충남북", value: "대전·충남북" },
              { label: "광주·전남북", value: "광주·전남북" },
              { label: "대구·경북", value: "대구·경북" },
              { label: "부산·울산·경남·제주", value: "부산·울산·경남·제주" },
            ],
          },
          // after: whereToUse(true, false),
          labelWidth: 120,
          disabled: mode === "view"
        },
      ],
      [
        {
          title: <> </>,
          placeholder: "경도/위도 입력",
          type: "button",
          color: "gray-line",
          label: "주소를 좌표로 변환",
          action: () => {
            getCoord(form, setForm);
          },
          labelWidth: 120,
          isHide: () => mode === "view"
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">8</span> */}
              </div>
              <div className="partner-form-title">
                경도
                {/* <span className="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          key: "longitude",
          type: "input",
          placeholder: "경도 입력",
          // tooltip:
          //   "변환된 좌표는 정확하지 않을 수 있습니다. 직접수정도 가능합니다.",
          // after: whereToUse(true, true),
          labelWidth: 120,
          isHide: () => mode === "view"
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">9</span> */}
              </div>
              <div className="partner-form-title">
                위도
                {/* <span className="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          key: "latitude",
          placeholder: "위도 입력",
          type: "input",
          // after: whereToUse(true, true),
          labelWidth: 120,
          isHide: () => mode === "view"
        },
      ],
    ]);
  }, [form]);

  useEffect(() => {
    setMode(orgMode);
  }, [orgMode]);

  useEffect(() => {
    const _buttons = [
      {
        label: "미리보기",
        color: "line",
        isHide: mode === "view",
        onClick: () => setPreviewOpen(true),
      },
      {
        label: "취소",
        color: "line",
        isHide: mode === "view",
        onClick: close,
      },
      {
        label: "수정하기",
        isHide: mode !== "modify",
        onClick: handleSubmit
      },
      {
        label: "등록하기",
        isHide: mode !== "create",
        onClick: handleSubmit
      },
      {
        label: "확인",
        onClick: close,
        isHide: mode !== "view"
      },
    ];

    setButtons(_buttons);
  }, [mode]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={close}
        className="consulitng-profile-moal"
      >
        <ModalHeader>
          {`${selectedItem?.name ? `${selectedItem?.name}의 ` : ""}컨설팅 정보${mode === "create" ? " 등록" : mode === "modify" ? " 수정" : ""}`}
        </ModalHeader>

        {employee && <div className="header-btn-wrap">
          <Button
            label="Biz 파트너 정보 불러오기"
            action={getPartnerData}
          />
        </div>}

        <div className="partner-site-wrap">
          <PartnerForm
            mode={mode}
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            fields2={fields2}
            onChange={handleOnChange}
            buttons={buttons}
          />
        </div>
      </Modal>
      <TaxEmployeePreviewModal
        isOpen={previewOpen}
        onClose={setPreviewOpen}
        employee={form}
      />
    </>
  );
};

export default TaxConsultingCompanyModal;